import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Alert } from "@ann/web-components";

const PromptDuplicateModal = ({ isOpen, onClose, onDuplicate, promptName, promptId}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  if (!isOpen) return null;

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="small"
        closeFromOutside={true}
      >
        <Modal.Header icon>
          <Modal.Header.Title>Duplicate this prompt?</Modal.Header.Title>
          <Modal.Header.Description>
            A copy of {promptName} will be created.
          </Modal.Header.Description>
          <Modal.Header.Description>
            You can edit the copy without affecting the original.{" "}
          </Modal.Header.Description>
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Actions align="center">
          <Modal.Button 
            label="Cancel" 
            onClick={onClose} 
            type="secondary" 
            disabled={isLoading}
          />
          <Modal.Button
            label={isLoading ? "Duplicating..." : "Duplicate"}
            onClick={async () => {
              setIsLoading(true);
              try {
                await onDuplicate();
                onClose();
              } catch (error) {
                setAlert({
                  title: "Error",
                  message: "There was an issue duplicating the prompt. Please try again.",
                  severity: "error"
                });
              } finally {
                setIsLoading(false);
              }
            }}
            type="primary"
            disabled={isLoading}
          />
        </Modal.Actions>
      </Modal>
      {alert && (
        <Alert
          title={alert.title}
          description={alert.message}
          severity={alert.severity}
          width={"692px"}
          top={"61px"}
          right={"16px"}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

PromptDuplicateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  promptName: PropTypes.string,
  promptId: PropTypes.string,
};

export default PromptDuplicateModal;
